document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.custom-select-container').forEach((customSelect) => {
    const selected = customSelect.querySelector('.custom-select-selected');
    const options = customSelect.querySelector('.custom-select-options');
    const hiddenInput = customSelect.querySelector('input[type="hidden"]');

    if (!selected || !options || !hiddenInput) return;

    const open = () => {
      options.hidden = false;
      selected.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      options.hidden = true;
      selected.setAttribute('aria-expanded', 'false');
    };

    selected.addEventListener('click', () => {
      if (options.hidden) open();
      else close();
    });

    selected.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (options.hidden) open();
        else close();
      }
      if (e.key === 'Escape') close();
    });

    document.addEventListener('click', (e) => {
      if (!customSelect.contains(e.target)) close();
    });

    customSelect.querySelectorAll('.custom-select-option').forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.getAttribute('data-value') || '';
        hiddenInput.value = value;
        selected.innerHTML = option.innerHTML;
        close();
      });
    });
  });
});
